<template>
  <div>
    <div
      v-if="loading"
      class="text-center"
      style="padding: 50px;"
    >
      <div
        class="spinner-border text-primary"
        role="status"
      >
        <span class="sr-only">Carregando...</span>
      </div>
      <p class="mt-2">
        Carregando registros...
      </p>
    </div>

    <div class="row">
      <div class="col-md-12">
        <router-link
          v-if="canApprove"
          class="btn btn-primary"
          style="float: right; margin-bottom: 20px;"
          :to="{ name: 'approve-check-adjustment-requests' }"
        >
          Aprovar/Reprovar Ajustes
        </router-link>
      </div>
    </div>
    <base-crud
      v-show="!loading"
      ref="baseCrud"
      crud-name="Ajustes de horário"
      new-text="Novo ajuste"
      :table="checkAdjustmentRequestsTable"
      :columns="columns"
      :options="options"
      :end-point="endPoint"
      :enable-add="canCreate"
      :enable-edit="false"
      :enable-delete="false"
      :enable-view="false"
      :data-form="dataForm"
    />
  </div>
</template>

<script>
import BaseCrud from '../Base/BaseCrud'

function format(datetime) {
  return moment(datetime).format('DD/MM/YYYY HH:mm')
}

export default {
  components: {
    BaseCrud,
  },
  data() {
    return {
      loading: true,

      checkAdjustmentRequestsTable: 'checkAdjustmentRequestsTable',
      endPoint: 'check-adjustment-requests/',
      columns: [
        'id',
        'user_id',
        'old_created_at',
        'new_created_at',
        'status',
      ],
      tableData: [
        'id',
        'user_id',
        'old_created_at',
        'new_created_at',
        'status',
      ],
      options: {
        filterByColumn: true,
        filterable: [
          'id',
          'user_id',
          'status',
        ],
        sortable: [
          'id',
          'user_id',
          'old_created_at',
          'new_created_at',
          'status',
        ],
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        pagination: { chunk: 10, dropdown: false, nav: 'scroll' },
        listColumns: {
          status: [
            { id: 1, text: 'Pendente' },
            { id: 2, text: 'Aprovado' },
            { id: 3, text: 'Rejeitado' },
          ],
        },
        texts: {
          filterPlaceholder: 'Selecione',
          selectStatusPlaceholder: 'Selecione',
        },

        headings: {
          id: 'ID',
          user_id: 'Usuário',
          old_created_at: 'Horário Antigo',
          new_created_at: 'Novo Horário',
          status: 'Status',
        },

        requestFunction(data) {
          const requestData = {}
          const query = this.$parent.$parent.$parent.query(data.query)
          requestData.params = data
          requestData.params.query = ''
          requestData.params.with = ['check', 'check.user', 'changes']
          return axios.get(`${this.url}?${query}`, requestData).catch(
            e => { this.dispatch('error', e) },
          )
        },

        params: {
          with: ['check', 'check.user', 'changes'],
        },
        templates: {
          user_id(h, row, index) {
            return row.check && row.check.user ? row.check.user.name : '-'
          },
          old_created_at(h, row, index) {
            if (row.changes && row.changes.length) {
              const change = row.changes[0]
              return format(change.old_created_at)
            }
            return row.check ? format(row.check.created_at) : '-'
          },
          new_created_at(h, row, index) {
            if (row.changes && row.changes.length) {
              const change = row.changes[0]
              return format(change.new_created_at)
            }
            return format(row.requested_created_at)
          },
          status(h, row, index) {
            const statusMap = {
              1: 'Pendente',
              2: 'Aprovado',
              3: 'Rejeitado',
            }
            return statusMap[row.status] || ''
          },
        },
      },
      dataForm: {},
    }
  },
  computed: {
    isAdminRole() {
      return parseInt(localStorage.getItem('is_admin'), 10) || 0
    },
    canCreate() {
      return this.isAdminRole !== 3
    },
    canApprove() {
      return this.isAdminRole === 1 || this.isAdminRole === 2 || this.isAdminRole === 4
    },
  },

  mounted() {
    const tableRef = this.$refs.baseCrud && this.$refs.baseCrud.$refs.table
    if (tableRef) {
      tableRef.$once('loaded', () => {
        this.loading = false
      })
    } else {
      this.loading = false
    }
  },

  methods: {
    query(query) {
      const columns = {
        id: 'id',
        user_id: 'name',
        status: 'status',
      }
      let filters = 'orderByDesc=id&'
      $.each(query, (index, value) => {
        filters += `${columns[index]}=${value}&`
      })
      return filters
    },
  },

}

</script>

<style scoped>
.badge {
	font-size: 0.85rem;
}
</style>
